import React, { useState } from 'react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../ui/dropdown-menu';
import { Button } from '../ui/button';

interface BorderedSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{ value: string; label: string }>;
  label?: string;
  error?: string;
  className?: string;
  textClassName?: string;
}

const BorderedSelect: React.FC<BorderedSelectProps> = ({
  options,
  label,
  error,
  className,
  textClassName,
  ...selectProps
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-col">
      <div
        className={`group relative rounded cursor-pointer ${error ? 'border-red-500' : ''} ${className}`}
        style={{
          paddingLeft: '1px',
          paddingRight: '5px',
          display: 'inline-block',
          maxWidth: '250px', // prevent drawer from being super wide
          maxHeight: 36,
        }}
      >
        <DropdownMenu
          open={open}
          onOpenChange={setOpen}
        >
          {label && (
            <label className="absolute -top-2 left-3 mb-1 text-xs font-light text-gray-500">
              {label}
            </label>
          )}
          <DropdownMenuTrigger asChild>

            <Button
              className={`appearance-none bg-transparent w-full px-3 py-2 rounded transition-all duration-300
                border-1 border-transparent 
                group-hover:border-gray-500 
                group-hover:border 
                //group-focus-within:border-1 
                //group-focus-within:border-gray-500
                //focus:outline-none
                ${error ? 'group-hover:border-red-500 group-focus-within:border-red-500' : ''}
                `}
              variant="ghost"
              size="med"
              onClick={() => setOpen(!open)}
            >

              <span className={`${textClassName || 'text-gray-500'}`}>
                {selectProps.value ? options.find((opt) => opt.value === selectProps.value)?.label : 'Select an option'}
              </span>
              {/* <ChevronDown className="size-4 text-gray-500 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" /> */}
            </Button>

          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {options.map((opt) => (
              <DropdownMenuItem
                key={opt.value}
                onClick={() => {selectProps.onChange?.({ target: { value: opt.value } } as unknown as React.ChangeEvent<HTMLSelectElement>);}}
              >
                {opt.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default BorderedSelect;
//           <option
//             value=""
//             disabled
//           >
//             Select an option
//           </option>
//           {options.map((opt) => (
//             <option
//               key={opt.value}
//               value={opt.value}
//               style={{
//                 padding: '6px 12px',
//                 fontSize: '0.95rem',
//                 lineHeight: 1.3,
//                 maxHeight: 32, // restrict option height
//               }}
//             >
//               {opt.label}
//             </option>
//           ))}
//         </select>
//         <ChevronDown
//           className={`text-transparent
//             group-hover:text-gray-500
//             group-focus-within:text-gray-500
//             focus:outline-none size-4
//             text-gray-500
//             absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none`}
//         />
//         {error && (
//           <span className="mt-1 text-xs text-red-500">
//             {error}
//           </span>
//         )}
//         <style>
//           {`
//           /* Reduce the dropdown options' box height in Chrome */
//           select {
//             max-height: 36px;
//           }
//           select:focus option {
//             max-height: 32px;
//           }
//           /* For Firefox: */
//           select, option {
//             max-height: 36px !important;
//           }
//         `}
//         </style>
//       </div>
//     </div>
//   );
// };

// export default BorderedSelect;
